// removed by extract-text-webpack-plugin
module.exports = {"overlay":"modal__overlay___1lJT5","content":"modal__content___18P08","header":"modal__header___1rphX","body":"modal__body___ElZfZ","footer":"modal__footer___12_2u undefined","command-button":"modal__command-button___3Wr2P","commandButton":"modal__command-button___3Wr2P"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/modal.css
// module id = 762
// module chunks = 0